<template>
  <v-dialog v-model="_dialog" max-width="500px" @click:outside="_dialog = false" @keydown="_dialog = false">
    <v-card>
      <v-card-title class="grey headline lighten-2">
        INFORMAÇÃO
        <v-icon style="opacity: 1" color="#e55239" size="30px">mdi-information-outline</v-icon>
      </v-card-title>
      <v-card-text>
        <slot name="text" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="_dialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      dialog: {
        type: Boolean,
        required: true
      }
    },

    emits: ['update:dialog'],

    computed: {
      _dialog: {
        get() {
          return this.dialog;
        },
        set(newValue) {
          this.$emit('update:dialog', newValue);
        }
      }
    }
  };
</script>
